import { useFormPersistenceContext } from '@/contexts/form-persistence'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, Typogaphy } from 'vnetwork-ui'

const FormPersistenceRestoreDialog = () => {
    const { t } = useTranslation()
    const { shouldRestore, acceptRestore, declineRestore } =
        useFormPersistenceContext()

    if (!shouldRestore) return null

    return (
        <Dialog
            open
            title={t('restore-form-persistence')}
            onClose={declineRestore}
        >
            <Typogaphy>{t('restore-form-persistence-confirmed')}</Typogaphy>
            <div className="flex justify-end gap-2 mt-4">
                <Button
                    variant="outlined"
                    onClick={declineRestore}
                    className="min-w-[100px]"
                >
                    {t('no')}
                </Button>
                <Button
                    variant="contained"
                    onClick={acceptRestore}
                    className="min-w-[150px]"
                >
                    {t('yes')}
                </Button>
            </div>
        </Dialog>
    )
}

export default FormPersistenceRestoreDialog
